import { Pipe, PipeTransform } from '@angular/core';

export interface ResponseErrors {
  placeholderWarning: boolean;
  googleUserWarning: boolean;
}

@Pipe({
  name: 'validateResponse',
  standalone: false,
})
export class ValidateResponsePipe implements PipeTransform {
  static validateResponse(response: string): ResponseErrors {
    if (!response) {
      return {
        placeholderWarning: false,
        googleUserWarning: false,
      };
    }

    return {
      placeholderWarning: !!response.match(/.*[{}[\]].*/g),
      googleUserWarning: response.includes('A Google User'),
    };
  }

  transform(response: string): ResponseErrors {
    return ValidateResponsePipe.validateResponse(response);
  }
}
